import { render } from "./Stop.vue?vue&type=template&id=074eb310"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Stop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "074eb310"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('074eb310', __exports__)) {
    api.reload('074eb310', __exports__)
  }
  
  module.hot.accept("./Stop.vue?vue&type=template&id=074eb310", () => {
    api.rerender('074eb310', render)
  })

}


export default __exports__